import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    legalTitleFemale: `Mrs. {0}`,
    legalTitleMale: 'Mr. {0}',
  },
  fr: {
    legalTitleFemale: 'Mme. {0}',
    legalTitleMale: 'M. {0}',
  },
} as const);
